import React, { ReactNode } from "react";
import * as styles from "./CustomFooter.module.css";

type CustomFooterProps = {
  children: ReactNode;
};

export const CustomFooter = ({ children }: CustomFooterProps) => (
  <div className={styles.container}>{children}</div>
);
